import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin, Shield, Scale, FileText, Truck, AlertTriangle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-8 sm:mt-16">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">R32</h3>
            <p className="text-xs sm:text-sm mb-3 sm:mb-4 leading-relaxed">
              R32.ro – marketplace online cu peste 250.000 de produse: fashion, haine de firmă, încălțăminte, ochelari de soare, cosmetice, parfumuri, produse IT, telefoane, huse, birotică, papetărie și electronice. Simple as you.
            </p>
            <div className="flex gap-1">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors hover:bg-white/10 hover:text-green-500">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors hover:bg-white/10 hover:text-green-500">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors hover:bg-white/10 hover:text-green-500">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors hover:bg-white/10 hover:text-green-500">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">Link-uri Utile</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/despre" className="hover:text-green-500 transition-colors">
                  Despre Noi
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-green-500 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/livrare" className="hover:text-green-500 transition-colors">
                  Livrare și Returnare
                </Link>
              </li>
              <li>
                <Link to="/garantie" className="hover:text-green-500 transition-colors">
                  Garanție
                </Link>
              </li>
              <li>
                <Link to="/termeni" className="hover:text-green-500 transition-colors">
                  Termeni și Condiții
                </Link>
              </li>
              <li>
                <Link to="/gdpr" className="hover:text-green-500 transition-colors">
                  Politica de Confidențialitate
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">Servicii Clienți</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/account" className="hover:text-green-500 transition-colors">
                  Contul Meu
                </Link>
              </li>
              <li>
                <Link to="/orders" className="hover:text-green-500 transition-colors">
                  Comenzile Mele
                </Link>
              </li>
              <li>
                <Link to="/formular-retur" className="hover:text-green-500 transition-colors flex items-center">
                  <FileText className="h-3 w-3 mr-1" />
                  Formular Returnare Produs
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="hover:text-green-500 transition-colors">
                  Lista de Dorințe
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-green-500 transition-colors">
                  Întrebări Frecvente
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">Contact</h3>
            <ul className="space-y-3 text-xs sm:text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Splaiul 1 Decembrie 1918, Bl. 28, Ap. 8<br />Lugoj, jud. Timiș, 305500</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 flex-shrink-0" />
                <a href="tel:+40765422686" className="hover:text-green-500">(0765) 422 686</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 flex-shrink-0" />
                <a href="mailto:contact@r32.ro" className="hover:text-green-500">contact@r32.ro</a>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-gray-400">Program:</p>
              <p className="text-xs">Luni - Vineri: 9:00 - 18:00</p>
              <p className="text-xs">Sâmbătă: 10:00 - 14:00</p>
            </div>
          </div>
        </div>

        {/* Legal Links Section */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6">
          <h3 className="text-white font-bold text-sm mb-4">Informații Legale</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 text-xs">
            <Link to="/formular-retur" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <FileText className="h-3 w-3" />
              <span>Formular Returnare</span>
            </Link>
            <Link to="/contact" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <Mail className="h-3 w-3" />
              <span>Contact</span>
            </Link>
            <Link to="/rechemare-produse" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <AlertTriangle className="h-3 w-3" />
              <span>Rechemare Produse</span>
            </Link>
            <Link to="/servicii-postale" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <Truck className="h-3 w-3" />
              <span>Servicii Poștale</span>
            </Link>
            <Link to="/anpc-sal" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <Scale className="h-3 w-3" />
              <span>ANPC - SAL</span>
            </Link>
            <Link to="/anpc" className="flex items-center space-x-1 hover:text-green-500 transition-colors">
              <Shield className="h-3 w-3" />
              <span>ANPC</span>
            </Link>
          </div>
        </div>

        {/* Bottom Bar - Responsive */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-xs sm:text-sm text-center sm:text-left">
              &copy; 2026 S.C. R32 COMPUTERS S.R.L. · CUI RO23799390 · J35/655/2008. Toate drepturile rezervate.
            </p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-xs sm:text-sm">
              <Link to="/termeni" className="hover:text-green-500">Termeni</Link>
              <span className="text-gray-700">|</span>
              <Link to="/gdpr" className="hover:text-green-500">Confidențialitate</Link>
              <span className="text-gray-700">|</span>
              <Link to="/politica-retur" className="hover:text-green-500">Retur</Link>
              <span className="text-gray-700">|</span>
              <Link to="/cookies" className="hover:text-green-500">Cookies</Link>
              <span className="text-gray-700">|</span>
              <Link to="/anpc" className="hover:text-green-500">ANPC</Link>
            </div>
          </div>
          
          {/* Payment & Trust Badges - Mobile optimized */}
          <div className="mt-6 sm:mt-8 flex flex-wrap justify-center items-center gap-4 sm:gap-6">
            <div className="flex items-center space-x-2 text-xs sm:text-sm">
              <div className="bg-white rounded px-2 py-1">
                <span className="font-bold text-gray-900">VISA</span>
              </div>
              <div className="bg-white rounded px-2 py-1">
                <span className="font-bold text-gray-900">Mastercard</span>
              </div>
              <div className="bg-white rounded px-2 py-1 text-xs">
                <span className="text-gray-900">🔒 SSL</span>
              </div>
            </div>
          </div>

          {/* ANPC Badges */}
          <div className="mt-4 flex flex-wrap justify-center items-center gap-4 text-xs text-gray-500">
            <a 
              href="https://anpc.ro/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1 hover:text-green-500"
            >
              <Shield className="h-4 w-4" />
              <span>ANPC</span>
            </a>
            <a 
              href="https://ec.europa.eu/consumers/odr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1 hover:text-green-500"
            >
              <Scale className="h-4 w-4" />
              <span>SOL - Soluționare Online Litigii</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
